/**
 * Journal d'audit (cahier §16.4, TODO phase 5) : catalogue des actions
 * journalisées. Partagé entre l'API (écriture) et le portail (libellés, filtres).
 * Chaque nouveau module ajoute ses actions ici.
 */
export const AUDIT_CATEGORIES = {
    auth: 'Connexions et sécurité des comptes',
    access: 'Contrôle d’accès',
    rbac: 'Profils et permissions',
    users: 'Comptes internes',
    competitions: 'Concours',
    forms: 'Formulaires',
    candidates: 'Candidats',
    applications: 'Candidatures',
    payments: 'Paiements',
    selection: 'Sélection',
    grading: 'Notes et commissions',
    results: 'Résultats et classements',
    documents_official: 'Convocations et documents officiels',
    notifications: 'Notifications',
    reports: 'Tableaux de bord et exports',
    audit: 'Journal d’audit',
};
const a = (label, category, sensitive = false) => ({
    label,
    category,
    sensitive,
});
export const AUDIT_ACTIONS = {
    // Connexions et comptes
    'auth.login': a('Connexion', 'auth'),
    'auth.login_failed': a('Échec de connexion', 'auth', true),
    'auth.mfa_failed': a('Code de double authentification incorrect', 'auth', true),
    'auth.logout': a('Déconnexion', 'auth'),
    'auth.logout_all': a('Déconnexion de tous les appareils', 'auth'),
    'auth.session_reuse': a('Réutilisation d’un jeton de session (vol suspecté)', 'auth', true),
    'auth.account_registered': a('Création d’un compte candidat', 'auth'),
    'auth.account_verified': a('Vérification d’un compte candidat', 'auth'),
    'auth.invitation_accepted': a('Activation d’un compte interne', 'auth'),
    'auth.password_changed': a('Changement de mot de passe', 'auth'),
    'auth.password_reset_requested': a('Demande de réinitialisation du mot de passe', 'auth'),
    'auth.password_reset': a('Réinitialisation du mot de passe', 'auth', true),
    'auth.mfa_enabled': a('Activation de la double authentification', 'auth'),
    'auth.mfa_disabled': a('Désactivation de la double authentification', 'auth', true),
    'auth.mfa_recovery_used': a('Utilisation d’un code de secours', 'auth', true),
    // Contrôle d'accès
    'access.denied': a('Accès refusé', 'access', true),
    // RBAC
    'rbac.role_created': a('Création d’un profil', 'rbac', true),
    'rbac.role_updated': a('Modification d’un profil', 'rbac', true),
    'rbac.role_deleted': a('Suppression d’un profil', 'rbac', true),
    'rbac.role_permissions_updated': a('Modification des permissions d’un profil', 'rbac', true),
    'rbac.role_assigned': a('Attribution d’un profil', 'rbac', true),
    'rbac.sod_forced': a('Cumul interdit forcé par un super-administrateur (séparation des responsabilités)', 'rbac', true),
    'rbac.role_revoked': a('Retrait d’un profil', 'rbac', true),
    // Comptes internes
    'user.invited': a('Invitation d’un compte interne', 'users'),
    'user.invitation_resent': a('Renvoi d’une invitation', 'users'),
    'user.updated': a('Modification d’un compte interne', 'users'),
    'user.disabled': a('Désactivation d’un compte', 'users', true),
    'user.enabled': a('Réactivation d’un compte', 'users', true),
    'user.mfa_reset': a('Réinitialisation de la double authentification', 'users', true),
    // Concours
    'competition.created': a('Création d’un concours', 'competitions'),
    'competition.updated': a('Modification d’un concours', 'competitions'),
    'competition.status_changed': a('Changement de statut d’un concours', 'competitions', true),
    'competition.extended': a('Prolongation des dépôts', 'competitions', true),
    'competition.milestones_updated': a('Modification du calendrier', 'competitions'),
    'competition.categories_updated': a('Modification des catégories', 'competitions'),
    'competition.notice_uploaded': a('Dépôt de l’avis officiel', 'competitions'),
    'competition.derogation_granted': a('Dérogation à la clôture accordée', 'competitions', true),
    'competition.derogation_revoked': a('Dérogation à la clôture retirée', 'competitions', true),
    'competition.form_linked': a('Association d’un formulaire au concours', 'competitions', true),
    // Formulaires
    'form.created': a('Création d’un formulaire', 'forms'),
    'form.updated': a('Modification d’un formulaire', 'forms'),
    'form.draft_saved': a('Enregistrement d’un brouillon de formulaire', 'forms'),
    'form.draft_discarded': a('Abandon d’un brouillon de formulaire', 'forms'),
    'form.published': a('Publication d’une version de formulaire', 'forms', true),
    // Candidats
    'candidate.profile_updated': a('Modification du profil candidat', 'candidates'),
    'candidate.photo_uploaded': a('Dépôt de la photo d’identité', 'candidates'),
    'candidate.id_scan_uploaded': a('Dépôt de la copie de la pièce d’identité', 'candidates'),
    'candidate.id_scan_scanned': a('Analyse antivirus de la copie de la pièce d’identité', 'candidates'),
    'candidate.id_scan_reviewed': a('Contrôle de la copie de la pièce d’identité', 'candidates', true),
    'candidate.id_scan_viewed': a('Consultation de la copie de la pièce d’identité', 'candidates'),
    'duplicate.detected': a('Doublon potentiel détecté', 'candidates', true),
    'duplicate.reviewed': a('Décision sur un doublon potentiel', 'candidates', true),
    'duplicate.rule_updated': a('Modification d’une règle de détection des doublons', 'candidates', true),
    // Candidatures
    'application.created': a('Création d’une candidature (brouillon)', 'applications'),
    'application.submitted': a('Soumission d’une candidature', 'applications'),
    'application.submit_refused': a('Soumission refusée (contrôles)', 'applications'),
    'application.withdrawn': a('Retrait d’une candidature', 'applications'),
    'selection.stage_created': a('Création d’une étape de sélection', 'selection'),
    'selection.stage_updated': a('Modification d’une étape de sélection', 'selection'),
    'selection.stage_deleted': a('Suppression d’une étape de sélection', 'selection'),
    'selection.stages_reordered': a('Réordonnancement des étapes', 'selection'),
    'selection.discipline_created': a('Ajout au catalogue des disciplines', 'selection'),
    'selection.discipline_updated': a('Modification du catalogue des disciplines', 'selection'),
    'selection.stage_discipline_added': a('Ajout d’une discipline à une étape', 'selection'),
    'selection.stage_discipline_updated': a('Modification d’une discipline (barème, coefficient)', 'selection'),
    'selection.stage_discipline_removed': a('Retrait d’une discipline d’une étape', 'selection'),
    'selection.rules_drafted': a('Rédaction d’une version des règles de passage', 'selection'),
    'selection.rules_validated': a('Validation des règles de passage', 'selection', true),
    'selection.scales_locked': a('Verrouillage des barèmes (ouverture de la notation)', 'selection'),
    'selection.scales_unlocked': a('Déverrouillage exceptionnel des barèmes', 'selection', true),
    'grading.population_built': a('Constitution de la liste des candidats d’une étape', 'grading'),
    'grading.anonymity_set': a('Activation / désactivation de l’anonymat', 'grading'),
    'grading.anonymity_lifted': a('Levée de l’anonymat', 'grading', true),
    'grading.lots_generated': a('Constitution des lots', 'grading'),
    'grading.lot_updated': a('Modification d’un lot (salle, centre)', 'grading'),
    'grading.assignment_created': a('Affectation d’un évaluateur', 'grading'),
    'grading.assignment_removed': a('Retrait d’une affectation', 'grading'),
    'grading.grades_saved': a('Saisie de notes', 'grading'),
    'grading.grades_corrected': a('Correction motivée de notes soumises', 'grading', true),
    'grading.sheet_submitted': a('Soumission d’un relevé de notes', 'grading'),
    'grading.sheet_reopened': a('Réouverture d’un relevé soumis (avant validation)', 'grading'),
    'grading.sheet_validated': a('Validation d’un relevé de notes', 'grading'),
    'grading.sheet_unlocked': a('Déverrouillage d’un relevé validé', 'grading', true),
    'results.ranking_computed': a('Calcul d’une version du classement', 'results'),
    'results.tie_resolved': a('Décision humaine sur un classement (ex æquo, mode manuel)', 'results', true),
    'results.ranking_submitted': a('Classement transmis au contrôle', 'results'),
    'results.ranking_returned': a('Classement renvoyé en brouillon', 'results'),
    'results.ranking_approved': a('Approbation d’un classement (visa de l’autorité)', 'results', true),
    'results.ranking_rejected': a('Classement renvoyé par l’autorité', 'results'),
    'results.published': a('Publication de résultats', 'results', true),
    'results.rectification_requested': a('Demande de rectification de résultats', 'results', true),
    'results.rectification_decided': a('Décision sur une demande de rectification', 'results', true),
    'grading.population_from_ranking': a('Liste d’une étape constituée depuis l’étape précédente', 'grading'),
    'centers.center_created': a('Création d’un centre d’examen', 'documents_official'),
    'centers.center_updated': a('Modification d’un centre d’examen', 'documents_official'),
    'centers.room_saved': a('Création / modification d’une salle', 'documents_official'),
    'centers.room_removed': a('Suppression d’une salle', 'documents_official'),
    'convocations.distributed': a('Répartition des candidats (convocations préparées)', 'documents_official'),
    'convocations.issued': a('Envoi des convocations', 'documents_official'),
    'convocations.cancelled': a('Annulation de convocations', 'documents_official', true),
    'documents.generated': a('Génération d’un document officiel', 'documents_official'),
    'documents.revoked': a('Révocation d’un document officiel', 'documents_official', true),
    'documents.batch_requested': a('Génération groupée de documents (archive ZIP)', 'documents_official'),
    'documents.downloaded': a('Téléchargement d’un document officiel par un agent', 'documents_official'),
    'notifications.template_updated': a('Modification d’un modèle de notification', 'notifications'),
    'notifications.template_reset': a('Retour au modèle de notification par défaut', 'notifications'),
    'notifications.provider_created': a('Ajout d’un fournisseur email / SMS', 'notifications', true),
    'notifications.provider_updated': a('Modification d’un fournisseur email / SMS', 'notifications', true),
    'notifications.provider_tested': a('Test d’un fournisseur email / SMS', 'notifications'),
    'notifications.campaign_sent': a('Envoi groupé de notifications', 'notifications'),
    'reports.export_requested': a('Demande d’export de données', 'reports', true),
    'reports.export_downloaded': a('Téléchargement d’un export de données', 'reports', true),
    'reports.export_purged': a('Suppression d’exports expirés', 'reports'),
    'notifications.delivery_retried': a('Nouvel essai d’envoi d’une notification', 'notifications'),
    'application.receipt_generated': a('Génération du récépissé', 'applications'),
    'application.review_started': a('Prise en charge d’un dossier', 'applications'),
    'application.assigned': a('Attribution d’un dossier à un agent', 'applications'),
    'application.complement_requested': a('Demande de complément', 'applications'),
    'application.complement_answered': a('Réponse du candidat à une demande de complément', 'applications'),
    'application.complement_expired': a('Délai de complément dépassé', 'applications'),
    'application.decision_proposed': a('Proposition de décision de recevabilité', 'applications', true),
    'application.decision_validated': a('Validation d’une décision de recevabilité', 'applications', true),
    'application.decision_returned': a('Proposition de décision renvoyée', 'applications', true),
    'application.notification_failed': a('Échec d’envoi d’une notification au candidat', 'applications'),
    'correction.requested': a('Demande de correction après dépôt', 'applications', true),
    'correction.approved': a('Correction après dépôt validée et appliquée', 'applications', true),
    'correction.rejected': a('Correction après dépôt refusée', 'applications', true),
    // Pièces justificatives
    'document.uploaded': a('Dépôt d’une pièce justificative', 'applications'),
    'document.removed': a('Retrait d’une pièce par le candidat', 'applications'),
    'document.rejected_upload': a('Fichier refusé au dépôt (type, taille)', 'applications'),
    'document.scanned': a('Analyse antivirus d’une pièce', 'applications'),
    'document.infected': a('Pièce refusée par l’antivirus', 'applications', true),
    'document.downloaded': a('Consultation d’une pièce par un agent', 'applications', true),
    'document.reviewed': a('Décision sur une pièce (acceptée / refusée)', 'applications', true),
    'payment.initiated': a('Paiement lancé par le candidat', 'payments'),
    'payment.confirmed': a('Paiement confirmé', 'payments', true),
    'payment.failed': a('Paiement échoué ou annulé', 'payments'),
    'payment.anomaly': a('Anomalie de paiement (montant, référence, transaction)', 'payments', true),
    'payment.webhook_rejected': a('Notification de paiement rejetée (authenticité)', 'payments', true),
    'payment.manual_entry': a('Saisie manuelle d’un paiement', 'payments', true),
    'payment.manual_confirmation': a('Validation manuelle d’un paiement en ligne après vérification', 'payments', true),
    'payment.refunded': a('Remboursement d’un paiement', 'payments', true),
    'payment.exported': a('Export des transactions', 'payments', true),
    'payment.reconciled': a('Rapprochement d’un relevé de prestataire', 'payments', true),
    'payment.receipt_generated': a('Génération du reçu de paiement', 'payments'),
    'payment_method.created': a('Création d’un moyen de paiement', 'payments', true),
    'payment_method.updated': a('Modification d’un moyen de paiement', 'payments', true),
    'payment_method.activated': a('Activation d’un moyen de paiement', 'payments', true),
    'payment_method.deactivated': a('Désactivation d’un moyen de paiement', 'payments', true),
    'payment_method.tested': a('Test de connexion d’un moyen de paiement', 'payments'),
    'competition.payment_methods_updated': a('Moyens de paiement acceptés par un concours', 'competitions', true),
    // Journal
    'audit.exported': a('Export du journal d’audit', 'audit', true),
};
export const AUDIT_RESULTS = {
    success: 'Réussi',
    denied: 'Refusé',
    error: 'Erreur',
};
export function isAuditAction(value) {
    return Object.hasOwn(AUDIT_ACTIONS, value);
}
/** Libellé lisible, y compris pour une action retirée du catalogue (anciennes lignes). */
export function auditActionLabel(action) {
    return isAuditAction(action) ? AUDIT_ACTIONS[action].label : action;
}
/** Clés jamais conservées en clair dans `before`, `after` ou `metadata`. */
export const AUDIT_REDACTED_KEYS = [
    'password',
    'currentPassword',
    'newPassword',
    'passwordConfirmation',
    'token',
    'accessToken',
    'refreshToken',
    'secret',
    'mfaSecret',
    'challenge',
    'recoveryCodes',
];
/** Masque récursivement les secrets (insensible à la casse, snake_case compris). */
export function redactAudit(value) {
    const keys = new Set(AUDIT_REDACTED_KEYS.map((k) => k.toLowerCase()));
    const normalize = (key) => key.replace(/_/g, '').toLowerCase();
    const walk = (input, depth) => {
        if (depth > 8 || input === null || typeof input !== 'object')
            return input;
        if (Array.isArray(input))
            return input.map((item) => walk(item, depth + 1));
        return Object.fromEntries(Object.entries(input).map(([key, item]) => [
            key,
            keys.has(normalize(key)) ? '[masqué]' : walk(item, depth + 1),
        ]));
    };
    return walk(value, 0);
}
/** Comparaison avant/après clé par clé (un niveau), pour l'affichage. */
export function auditDiff(before, after) {
    const asObject = (v) => v && typeof v === 'object' && !Array.isArray(v) ? v : {};
    const b = asObject(before);
    const a2 = asObject(after);
    const keys = [...new Set([...Object.keys(b), ...Object.keys(a2)])].sort();
    return keys.map((key) => ({
        key,
        before: b[key],
        after: a2[key],
        changed: JSON.stringify(b[key]) !== JSON.stringify(a2[key]),
    }));
}
//# sourceMappingURL=audit.js.map